import { atom } from "jotai";

export const confettiCollabsAtom = atom<boolean>(false);

export const fundedCollabIdAtom = atom<string | null>(null);
